import React from 'react';
import { useStore } from '../store/store';
import { Text, Tabs, Box, Flex, Button } from "@radix-ui/themes";
import Icon from '@mdi/react';
import { mdiAccount, mdiMapMarker, mdiFeather, mdiChevronRight } from '@mdi/js';

export const SidebarWorld = (props) => {
    const [state, actions] = useStore();

    const characters = state.currentNovel?.characters?.map(character => {
        return <div key={character.id} className="sidebar-character-item" onClick={() => {
                if(props.selectedCharacter?.id === character?.id) {
                    props.setSelectedCharacter(null);
                } else {
                    props.setSelectedCharacter(character);
                }
            }}>
            <Flex justify={'between'} align={'center'}>
                <Flex direction="column" align={'start'}>
                    <Text as='div' size={"3"}>{character.name}</Text>
                    <Text as='div' size={"1"}>{character.role}</Text>
                </Flex>
                {props.selectedCharacter?.id === character?.id ? <Icon path={mdiChevronRight} size={1}/> : null}
            </Flex>
        </div>;
    });

    const locations = state.currentNovel?.locations?.map(location => {
        return <div key={location.id} className="sidebar-character-item" onClick={() => {
                if(props.selectedLocation?.id === location?.id) {
                    props.setSelectedLocation(null);
                } else {
                    props.setSelectedLocation(location);
                }
            }}>
            <Flex justify={'between'} align={'center'}>
                <Flex direction="column" align={'start'}>
                    <Text as='div' size={"3"}>{location.name}</Text>
                </Flex>
                {props.selectedLocation?.id === location?.id ? <Icon path={mdiChevronRight} size={1}/> : null}
            </Flex>
        </div>;
    });

    const lore = state.currentNovel?.lore?.map(lore => {
        return <div key={lore.id} className="sidebar-character-item" onClick={() => {
                if(props.selectedLore?.id === lore?.id) {
                    props.setSelectedLore(null);
                } else {
                    props.setSelectedLore(lore);
                }
            }}>
            <Flex justify={'between'} align={'center'}>
                <Flex direction="column" align={'start'}>
                    <Text as='div' size={"3"}>{lore.name}</Text>
                </Flex>
                {props.selectedLore?.id === lore?.id ? <Icon path={mdiChevronRight} size={1}/> : null}
            </Flex>
        </div>;
    });

    return (
        <div>
            <Tabs.Root defaultValue="characters">
                <Tabs.List color="cyan" style={{color: 'white'}}>
                    <Tabs.Trigger value="characters" onClick={() => props.resetSideSidebar()}>
                        <Icon path={mdiAccount} size={1}/>
                        &nbsp;Characters
                    </Tabs.Trigger>
                    <Tabs.Trigger value="locations" onClick={() => props.resetSideSidebar()}>
                        <Icon path={mdiMapMarker} size={1} />
                        &nbsp;Locations
                    </Tabs.Trigger>
                    <Tabs.Trigger value="lore" onClick={() => props.resetSideSidebar()}>
                        <Icon path={mdiFeather} size={1} />
                        &nbsp;Lore
                    </Tabs.Trigger>
                </Tabs.List>
                <Box pt="3">
                    <Tabs.Content value="characters">
                        {characters}
                        <div className="sidebar-add-new-button-wrapper">
                            {!state.readOnly && <Button className="sidebar-add-new-button" onClick={() => {props.setSelectedCharacter({new: true})}}>+ New Character</Button>}
                        </div>
                    </Tabs.Content>

                    <Tabs.Content value="locations">
                        {locations}
                        <div className="sidebar-add-new-button-wrapper">
                        {!state.readOnly && <Button className="sidebar-add-new-button" onClick={() => {props.setSelectedLocation({new: true})}}>+ New Location</Button>}
                        </div>
                    </Tabs.Content>

                    <Tabs.Content value="lore">
                        {lore}
                        <div className="sidebar-add-new-button-wrapper">
                        {!state.readOnly && <Button className="sidebar-add-new-button" onClick={() => {props.setSelectedLore({new: true})}}>+ New Lore Item</Button>}
                        </div>
                    </Tabs.Content>
                </Box>
            </Tabs.Root>
        </div>
    );
};

export default SidebarWorld;